module.exports = __webpack_public_path__ + "img/error-img.80c068b9.png";